import { IconDefinition } from "./types";

const tick: IconDefinition = {
  iconName: "tick",
  width: 16,
  height: 16,
  svgPathData: "M2.5 8.43l4.257 4.565L13.5 3",
  iconType: "stroke",
};

export { tick };
